// components/SocialLoginButton.tsx

"use client";

import { useRouter } from "next/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface SocialLoginButtonProps {
  icon: IconProp;
  iconColor: string;
  bgColor: string;
  textColor: string;
  text: string;
  href: string;
}

export function SocialLoginButton({
  icon,
  iconColor,
  bgColor,
  textColor,
  text,
  href,
}: SocialLoginButtonProps) {
  const router = useRouter();

  return (
    <button
      className={`
    w-full flex flex-row items-center justify-center py-3 rounded-xl 
    transition-all duration-200 ease-in-out group

    ${bgColor} 
    
    hover:brightness-90
    active:brightness-80
    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-opacity-50
  `}
      onClick={() => router.push(href)}
    >
      <FontAwesomeIcon
        icon={icon}
        size="xl"
        color={iconColor}
        className="
        mr-2
        transition-colors duration-200 ease-in-out group-hover:opacity-85
        flex-none self-center 
    
        translate-y-px 
      "
      />

      <p
        className={`medium-text-15 ${textColor} transition-colors duration-200 ease-in-out group-hover:opacity-85`}
      >
        {text}
      </p>
    </button>
  );
}
